"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this._eventMap = {};
    }
    EventEmitter.prototype.on = function (event, fn, context) {
        var eventHandlers = this._eventMap[event];
        var newHandler = { context: context, fn: fn, once: false };
        if (util_1.isArray(eventHandlers)) {
            eventHandlers.push(newHandler);
        }
        else {
            this._eventMap[event] = [newHandler];
        }
    };
    EventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var handlers = this._eventMap[event];
        if (util_1.isArray(handlers)) {
            for (var i = 0; i < handlers.length; i++) {
                var _a = handlers[i], context_1 = _a.context, fn = _a.fn, once = _a.once;
                fn.apply(context_1, args);
                if (once) {
                    handlers.splice(i, 1);
                    i--;
                }
            }
        }
    };
    EventEmitter.prototype.off = function (event, fn) {
        var handlers = this._eventMap[event];
        if (handlers && handlers.length) {
            var index = handlers.findIndex(function (handler) { return handler.fn === fn; });
            if (index > -1) {
                handlers.splice(index, 1);
            }
        }
    };
    return EventEmitter;
}());
exports.default = EventEmitter;
//# sourceMappingURL=event.js.map